import { map } from 'rxjs/operators';
import { API_URL } from 'consts/common.const';
import { Http, Response } from 'services/http';
import { setMasterData } from 'services/master-data/master-data.service';

interface MasterDataRes {
  masterId: number;
  parent?: number;
  masterName: string;
  groupName: string;
}

export interface MasterDataItem {
  label: string;
  value: number;
  parent?: number;
}

export interface MasterData {
  [groupName: string]: Array<MasterDataItem>;
}

export const masterData = () => {
  return Http.request<MasterDataRes[]>({
    method: 'GET',
    url: `${API_URL}/masterdata`,
  }).pipe(
    map((res: Response<MasterDataRes[]>) => {
      const masterData = res.data;

      const newMasterData: MasterData = masterData.reduce((prev, curr) => {
        if (prev[curr.groupName]) {
          prev[curr.groupName] = [
            ...prev[curr.groupName],
            {
              value: curr.masterId,
              label: curr.masterName,
              parent: curr.parent,
            },
          ];
        } else {
          prev[curr.groupName] = [
            {
              value: curr.masterId,
              label: curr.masterName,
              parent: curr.parent,
            },
          ];
        }

        return prev;
      }, {} as MasterData);

      setMasterData(newMasterData);

      return newMasterData;
    })
  );
};
